module.exports = __webpack_public_path__ + "static/img/1.6dd45ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newbieGuide/img/1.png
// module id = OX4d
// module chunks = 118